import { useState, useEffect } from "react";
import Button from "./base/Button.jsx";
import { theme } from "../theme.js";
import { DEFAULT_IMAGE } from "../utils/constants.js";
import { PhotoIcon } from "@heroicons/react/24/outline";

function HeroBase({ title, type, image, editable, handleChange, onImageChange }) {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const handleImageError = (e) => {
        console.error("Image failed to load:", image);
        e.target.style.display = 'none';
    };

    const handleImageLoad = (e) => {
        console.log("Image loaded successfully:", image);
    };

    return (<div style={styles.hero}>
        {image || !editable ? (
          <img 
            src={image || DEFAULT_IMAGE}
            alt={title} 
            style={styles.heroImage}
            onError={handleImageError}
            onLoad={handleImageLoad}
            crossOrigin="anonymous"
          />
        ) : (
          <div style={styles.heroPlaceholder}>
          </div>
        )}
        <div style={styles.heroOverlay}></div>
        <div style={styles.heroContent}>
          {editable ? (
            <input name="title" type="text" style={{...styles.titleForm, fontSize: isMobile ? "40px" : "50px"}} value={title} onChange={handleChange} />
            ) : (<h1 style={{ ...styles.title, fontSize: isMobile ? "40px" : "50px" }}>{title} </h1>)
          }
          {editable ? null : (
            <div style={styles.heroMeta}>
              <span style={styles.category}>{ type }</span>
            </div>
          )}
        </div>
        {editable && (
          <div style={styles.uploadButtonContainer}>
            <Button 
              icon={PhotoIcon}
              title="Ajouter une image" 
              onClick={() => document.getElementById('heroImageInput').click()}
              style="dark"
            />
          </div>
        )}
        {editable && (
          <input
            id="heroImageInput"
            type="file"
            accept="image/*"
            onChange={onImageChange}
            style={{ display: 'none' }}
          />
        )}
      </div>
    );
}

export function HeroReadOnly({ title, type, image }) {
    return (<HeroBase title={title} type={type} image={image} editable={false} />);
  }

export function HeroEditable({ formData, handleChange, onImageChange }) {
    return (<HeroBase 
      title={formData.title} 
      type={formData.type} 
      image={formData.image} 
      editable={true} 
      handleChange={handleChange}
      onImageChange={onImageChange}
    />);
  }

const styles = {
    hero: {
    position: "relative",
    height: "400px",
    overflow: "hidden",
    backgroundColor: theme.colors.bgLight,
  },
  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  heroPlaceholder: {
    width: "100%",
    height: "100%",
    background: `linear-gradient(160deg, ${theme.colors.bgDark} 0%, ${theme.colors.bgDark} 50%, ${theme.colors.light} 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.colors.bgDark,
    opacity: 0.5,
    },
  heroContent: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "40px 20px",
    color: theme.colors.textLight,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    height: "100%",
  },
  title: {
    fontWeight: "bold",
    margin: "0 0 16px 0",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
    titleForm: {
    fontWeight: "bold",
    margin: "0 0 16px 0",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    background: "transparent",
    border: "none",
    borderBottom: `2px solid ${theme.colors.textLight}`,
    color: theme.colors.textLight,
    outline: "none",
    width: "40%",
  },
  heroMeta: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },category: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    color: theme.colors.textLight,
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: "600",
  },
  uploadButtonContainer: {
    position: "absolute",
    top: "16px",
    right: "16px",
    zIndex: 10,
    width: "auto",
    maxWidth: "200px",
  },
}